<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol content-mb-14"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_HIGH_TECH_ORDER_ID'
        )
      }"
    >
      <p class="content-s-2-label">
        <label>Выберете приказ, в который включена Ваша продукция:</label>
      </p>
      <select
        v-model="$parent.project.SETTING_TABLE.allData.UF_HIGH_TECH_ORDER_ID"
        class="sel-dropdown i-main-style i-wid-50"
        v-on:change="changeVidProduction()"
        :disabled="$parent.$parent.projectDisabled"
      >
        <option value=""></option>
        <option
          v-for="item in getListPromProduct()"
          v-bind:value="item.ID"
          v-bind:key="item.ID"
          v-text="item.NAME"
        ></option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_HIGH_TECH_ORDER_ID"
          )
        }}
      </div>
    </div>
    <div
      class="col-xs-12 mycol content-mb-14"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_HIGH_TECH_ORDER_ID'
        )
      }"
    >
      <p class="content-s-2-label">
        <label>Наименование продукции:</label>
      </p>
      <select
        v-model="$parent.project.SETTING_TABLE.allData.UF_HIGH_TECH_PRODUCT_ID"
        class="sel-dropdown i-main-style i-wid-50"
        v-on:change="
          $parent.$parent.removeError(
            'PROJECTS',
            'LOGIC',
            'UF_HIGH_TECH_PRODUCT_ID'
          )
        "
        :disabled="$parent.$parent.projectDisabled"
      >
        <option value=""></option>
        <option
          v-for="item in vidPodclass"
          v-bind:value="item.ID"
          v-bind:key="item.ID"
          v-text="item.NAME"
        ></option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_HIGH_TECH_PRODUCT_ID"
          )
        }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HighTechProducts",
  computed: {
    vidPodclass() {
      if (
        this.$parent.project.SETTING_TABLE.allData.UF_HIGH_TECH_ORDER_ID < 1
      ) {
        return [];
      }

      let t = this.$parent.directory.tree_sp_orders_high_tech_industry.filter(
        c =>
          c.ID ===
          this.$parent.project.SETTING_TABLE.allData.UF_HIGH_TECH_ORDER_ID
      );

      console.log(t);

      if (t.length > 0) {
        return t[0].ELEMENT_ID;
      }

      return [];
    }
  },
  methods: {
    inArray(needle, haystack) {
      var length = haystack.length;
      for (var i = 0; i < length; i++) {
        if (haystack[i] == needle) return true;
      }
      return false;
    },
    getListPromProduct() {
      let returnList = [];
      this.$parent.directory.tree_sp_orders_high_tech_industry.forEach(function(
        el
      ) {
        returnList.push(el);
      },
      this);
      return returnList;
    },
    changeVidProduction() {
      this.$parent.project.SETTING_TABLE.allData.UF_HIGH_TECH_PRODUCT_ID = "";
      this.$parent.$parent.removeError(
        "PROJECTS",
        "LOGIC",
        "UF_HIGH_TECH_PRODUCT_ID"
      );
    }
  }
};
</script>

<style scoped></style>
